import * as React from "react"

const SvgClose = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M10.586 12 7.05 8.464q-.3-.3-.3-.707 0-.405.3-.707.3-.3.707-.3t.707.3L12 10.586l3.536-3.536q.3-.3.707-.3.405 0 .707.3.3.3.3.707t-.3.707L13.414 12l3.536 3.536q.3.3.3.707 0 .405-.3.707-.3.3-.707.3a.97.97 0 0 1-.707-.3L12 13.414 8.464 16.95q-.3.3-.707.3a.97.97 0 0 1-.707-.3q-.3-.3-.3-.707t.3-.707z" />
  </svg>
)
export default SvgClose
